import React from 'react'

import * as css from './LiderDetalles.css'

let PropTypes = React.PropTypes

export class RowLiderDetalles extends React.Component{
    constructor(props){
        super(props)
        this.inputOnKeyDown = this.inputOnKeyDown.bind(this)
        this.buscarComuna = this.buscarComuna.bind(this)
        this.state = {
            detalleLider: [],
            comunas: []
        }
        this.onInputChange = (key, evt)=>{
            let actualizado = {}
            if(key === 'idComunaOrigen'){
                actualizado[key] = this.buscarComuna(evt.target.value)
                actualizado.nombreComunaOrigen = evt.target.value
            }else if(key === 'idComunaSecundaria') {
                actualizado[key] = this.buscarComuna(evt.target.value)
                actualizado.nombreComunaSecundaria = evt.target.value                
            }else{
                actualizado[key] = evt.target.value
            }

            if(key == 'viatico' && evt.target.value)
                actualizado.medioViatico = evt.target.value/2
            actualizado.dirty = 1
            this.setState({ detalleLider: Object.assign({}, this.state.detalleLider, actualizado)})
        }
        this.onInputBlur =()=>{
            if(this.state.detalleLider.dirty){
                this.context.guardarDetalle(this.state.detalleLider.idLiderDetalle, this.state.detalleLider)
                    .then(resp=>{
                        console.log(resp)
                        let detalleLider = this.state.detalleLider
                        detalleLider.idLiderDetalle = resp
                        this.setState({
                            detalleLider
                        })
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        }
    }
    buscarComuna(nombre){
        for (var i=0; i < this.state.comunas.length; i++) {
            if (this.state.comunas[i].nombre === nombre) {
                return this.state.comunas[i].cutComuna;
            }
        }
    }
    focusElemento(elemento){
        this[elemento].focus()
    }
    inputOnKeyDown(key, evt){
        if((evt.keyCode===9 && evt.shiftKey===false) || evt.keyCode===40 || evt.keyCode===13){
            // 9 = tab, flechaAbajo = 40,  13 = enter
            evt.preventDefault()
            this.props.focusRow(this.props.index+1, key)

        }else if((evt.keyCode===9 && evt.shiftKey===true) || evt.keyCode===38) {
            // flechaArriba = 38, shift+tab
            evt.preventDefault()
            this.props.focusRow(this.props.index-1, key)
        }
    }
    componentWillMount(){
        this.setState({
            comunas: this.props.comunas,
            detalleLider: this.props.lider
        })
    }
    render() {
        return (
            <tr key={this.props.index}>
                {/* Rut */}
                <td className={css.tdRut} title={this.props.index}>{this.state.detalleLider.usuarioRUN+"-"+this.state.detalleLider.usuarioDV}</td>
                {/* Nombre */}
                <td className={css.tdNombre} >{this.state.detalleLider.nombreCorto}</td>
                {/* Colación */}
                <td className={css.tdColacion}>
                    <input type="number" className={"form-control "+css.inputGeneral}
                        ref={(colacion) => { this.inputColacion = colacion }}
                        min="0"
                        value={this.state.detalleLider.colacion}
                        disabled={!this.state.detalleLider.estado_lider}
                        onFocus={()=>{ this.inputColacion.select() }}
                        onKeyDown={this.inputOnKeyDown.bind(this, 'inputColacion')}
                        onChange={this.onInputChange.bind(this, 'colacion')}
                        onBlur={this.onInputBlur}/>
                </td>
                {/* Viático 100% */}
                <td className={css.tdViatico}>
                    <input type="number" className={"form-control "+css.inputGeneral}
                        ref={(viatico) => { this.inputViatico = viatico }}
                        min="0"
                        value={this.state.detalleLider.viatico}
                        disabled={!this.state.detalleLider.estado_lider}
                        onFocus={()=>{ this.inputViatico.select() }}
                        onKeyDown={this.inputOnKeyDown.bind(this, 'inputViatico')}
                        onChange={this.onInputChange.bind(this, 'viatico')}
                        onBlur={this.onInputBlur}/>
                </td>
                {/* Viático 50% */}
                <td className={css.tdViatico}>
                    <input type="number" className={"form-control "+css.inputGeneral}
                        ref={(medioViatico) => { this.inputMedioViatico = medioViatico }}
                        min="0"
                        value={this.state.detalleLider.medioViatico}
                        disabled={!this.state.detalleLider.estado_lider}
                        onFocus={()=>{ this.inputMedioViatico.select() }}
                        onKeyDown={this.inputOnKeyDown.bind(this, 'inputMedioViatico')}
                        onChange={this.onInputChange.bind(this, 'medioViatico')}
                        onBlur={this.onInputBlur}/>
                </td>
                {/* Origen 1 */}
                <td className={css.tdOrigen}>
                    <input type="text" list="comunas" placeholder="Buscar comuna"
                        className={"form-control "+css.inputGeneral}
                        ref={(idComunaOrigen) => { this.inputIdComunaOrigen = idComunaOrigen }}
                        value={this.state.detalleLider.nombreComunaOrigen}
                        disabled={!this.state.detalleLider.estado_lider}
                        onKeyDown={this.inputOnKeyDown.bind(this, 'inputIdComunaOrigen')}
                        onChange={this.onInputChange.bind(this, 'idComunaOrigen')}
                        onBlur={this.onInputBlur}/>
                    <datalist id="comunas">
                        {this.state.comunas.map((comuna, index)=>{
                            return <option key={comuna.cutComuna} value={comuna.nombre}/>
                        })}
                    </datalist>
                </td>
                {/* Origen 2 */}
                <td className={css.tdOrigen}>
                    <input type="text" list="comunas" placeholder="Buscar comuna" 
                        className={"form-control "+css.inputGeneral}
                        ref={(idComunaSecundaria) => { this.inputIdComunaSecundaria = idComunaSecundaria }}
                        value={this.state.detalleLider.nombreComunaSecundaria}
                        disabled={!this.state.detalleLider.estado_lider}
                        onKeyDown={this.inputOnKeyDown.bind(this, 'inputIdComunaSecundaria')}
                        onChange={this.onInputChange.bind(this, 'idComunaSecundaria')}
                        onBlur={this.onInputBlur}/>
                    <datalist id="comunas">
                        {this.state.comunas.map((comuna, index)=>{
                            return <option key={comuna.cutComuna} value={comuna.nombre}/>
                        })}
                    </datalist>
                </td>
            </tr>
        )
    }
}
RowLiderDetalles.contextTypes = {
    guardarDetalle: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/admin/lider-detalles/RowLiderDetalles.jsx